import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { OwnersComponent } from './owners.component';
import { OwnFiltersComponent } from './owners-filters/owners-filters.component';

import { ListService } from '../list.service';

import { AngularMaterialModule } from '../angular-material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule
  ],
  providers: [
    OwnFiltersComponent,
    ListService
  ],
  declarations: [
    OwnersComponent,
    OwnFiltersComponent
  ],
  exports: [
    OwnersComponent
  ]
})
export class OwnersModule { }
